import { css } from 'linaria';

export const brandsTitle = css`
  width: 100%;
  margin-bottom: 32px;

  @media (--to-desktop) {
    margin-bottom: 24px;
  }
`;

export const brandsCards = css`
  display: flex;
  column-gap: 20px;

  @media (--only-tablet) {
    column-gap: 16px;
  }

  @media (--only-mobile) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }
`;

export const brandsCard = css`
  width: 280px;
  height: 100%;
  border-radius: var(--rounding-xl);

  @media (--only-desktop) {
    width: 220px;
  }

  @media (--only-tablet) {
    width: 156px;
  }

  @media (--only-mobile) {
    height: 100px;
    width: 100%;
  }
`;

export const brandsCardImage = css`
  border-radius: var(--rounding-xl);
  height: 100%;
  width: 100%;

  @media (--only-mobile) {
    width: 100%;
    object-fit: cover;
  }
`;
